import { render, staticRenderFns } from "./EventFormat.vue?vue&type=template&id=064ca570"
import script from "./EventFormat.vue?vue&type=script&lang=js"
export * from "./EventFormat.vue?vue&type=script&lang=js"
import style0 from "./EventFormat.vue?vue&type=style&index=0&id=064ca570&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports